"use strict";

import angular from "angular";

import { Validations } from "../../imports/validations";

const name = "hasPermission";
const factory = [
    "$timeout",
    ($timeout) => ({
        restrict: "A",
        link: ($scope, $elem, $attr) => {
            const permission = $attr.hasPermission;
            if (!permission) return true;
            const method = $attr.hasPermission.split(".");
            const loadPermission = () => {
                if (!Validations.getPermission(method[0], method[1]))
                    $elem.remove();
            };
            loadPermission();
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
